import type { LogoType } from '../../types';

export const partners: LogoType[] = [
  {
    id: 'f5481c45',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo1.png',
        name: 'logo1.png',
        alt: '',
        width: 299,
        height: 267
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '33219d54',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo2.png',
        name: 'logo2.png',
        alt: '',
        width: 300,
        height: 261
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '6ac6c45c',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo4.png',
        name: 'logo4.png',
        alt: '',
        width: 318,
        height: 299
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'd4cf0739',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo6.png',
        name: 'logo6.png',
        alt: '',
        width: 300,
        height: 237
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '39dfe688',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo8.png',
        name: 'logo8.png',
        alt: '',
        width: 300,
        height: 300
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '7471cccb',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo9.png',
        name: 'logo9.png',
        alt: '',
        width: 300,
        height: 171
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'a0c937f9',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo10.png',
        name: 'logo10.png',
        alt: '',
        width: 230,
        height: 298
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '6543361c',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo11.png',
        name: 'logo11.png',
        alt: '',
        width: 297,
        height: 260
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '094eabb8',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo12.png',
        name: 'logo12.png',
        alt: '',
        width: 274,
        height: 75
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '07f126fc',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo13.png',
        name: 'logo13.png',
        alt: '',
        width: 300,
        height: 180
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'c7fdd309',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo14.png',
        name: 'logo14.png',
        alt: '',
        width: 300,
        height: 140
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '1ee196ae',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo15.png',
        name: 'logo15.png',
        alt: '',
        width: 299,
        height: 105
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  }
];
